<template>
  <!-- Выше диалогов (UiDialog — 2400): уведомление об ошибке не должно прятаться под подложку. -->
  <v-snackbar v-model="notification.visible.value" :color="snackbarColor" :timeout="-1" location="bottom right"
              :z-index="2500">
    {{ notification.current.value.message }}
    <template #actions>
      <v-btn variant="text" @click="notification.close()">
        <UiIcon :icon="mdiClose" size="18"/>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {UiIcon} from '@ismet/vue-ui-kit';
import {mdiClose} from '@mdi/js';
import {useNotification} from "@/shared/lib/hooks/useNotification";

const notification = useNotification();

const snackbarColor = computed(() => {
  switch (notification.current.value.type) {
    case 'success':
      return 'success';
    case 'error':
      return 'error';
    default:
      return 'info';
  }
});
</script>
